import { lazy } from 'react'
import baichuan_logo from '@/assets/images/app-logo/safepoint.png'
// import IP_Logo from '@/assets/images/app-logo/ip.png'

import LazyLoadable from '../components/LazyLoadable'

// import intelligenceRouters from './app/intelligenceRouters'
import platformRouters from './app/platformRouters'

const MenuLayout = LazyLoadable(lazy(() => import('@/Layout/MenuLayout')))

const appRouter = [
  {
    name: '百川后台',
    element: (
      <MenuLayout
        title='Safepoint 管理后台'
        logo={baichuan_logo}
        route={{
          path: 'platform',
          children: platformRouters,
        }}
      />
    ),
    children: platformRouters,
  },

  // {
  //   name: 'Intelligence Search',
  //   element: (
  //     <MenuLayout
  //       title='Intelligence Search'
  //       logo={IP_Logo}
  //       route={{
  //         path: 'ip',
  //         children: intelligenceRouters,
  //       }}
  //     />
  //   ),
  //   children: intelligenceRouters,
  // },
]

export default appRouter
